import { isUrl } from '@Utils/helpers/stringHelpers';
import React from 'react';
import { useSelector } from 'react-redux';
import { useResizeDetector } from 'react-resize-detector';
import { QualityControlApi } from '@Data/qualityControl/Api';
import { ImageIndex } from '@Data/qualityControl/Interfaces';
import {
    imageIndicesState,
    svgImageUrlsState,
    svgViewerDataState,
} from '@Data/qualityControl/Reducer';
import {
    getBorderColor,
    getImageContainerWidth,
    getImageXCoordinates,
} from '../SVGHelpers';
import { CAROUSEL_HEIGHT, RESIZE_REFRESH_DELAY } from '../constants';
import { ImageCarousel } from './ImageCarousel';
import Styles from './ImageCarousel.scss';

export const ImageCarouselController = () => {
    const { width, ref } = useResizeDetector({
        refreshMode: 'debounce',
        refreshRate: RESIZE_REFRESH_DELAY,
    });

    const carouselWidth = getImageContainerWidth(width);

    const controllerCoordinates = getImageXCoordinates(width, carouselWidth);
    const svgData = useSelector(svgViewerDataState);
    const svgImageUrls = useSelector(svgImageUrlsState);
    const imageIndices = useSelector(imageIndicesState);

    const handleChangeImage = async (
        imageIndex: ImageIndex,
        isNext: boolean
    ) => {
        const imageUrls = svgImageUrls[imageIndex];
        const currentIndex = imageIndices[imageIndex];

        let newIndex = isNext ? currentIndex + 1 : currentIndex - 1;

        if (newIndex === -1) {
            newIndex = imageUrls.length - 1;
        }

        if (newIndex === imageUrls.length) {
            newIndex = 0;
        }

        QualityControlApi.updateSvgImageIndex(
            imageIndex,
            newIndex as ImageIndex
        );

        if (!isUrl(imageUrls[newIndex])) {
            QualityControlApi.updateAreImagesLoading(imageIndex, true);
            await QualityControlApi.updateSingleImageUrlInTruesizeArray(
                imageIndex,
                newIndex as ImageIndex,
                imageUrls[newIndex]
            );
            QualityControlApi.updateAreImagesLoading(imageIndex, false);
        }
    };

    return (
        <div
            ref={ref}
            style={{ height: CAROUSEL_HEIGHT }}
            className={Styles.carouselControllerContainer}
        >
            {imageIndices.map((_, i) => {
                return (
                    <ImageCarousel
                        width={carouselWidth}
                        height={CAROUSEL_HEIGHT}
                        offset={controllerCoordinates[i]}
                        index={i}
                        title={svgData[i].title}
                        bearing={svgData[i].bearing ?? null}
                        distance={svgData[i].distance ?? null}
                        onChangeImage={handleChangeImage}
                        key={`imageCarousel${i}`}
                        borderColor={getBorderColor(i)}
                    />
                );
            })}
        </div>
    );
};
